<template>
    <svg
        :class="[direction]"
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="10"
        viewBox="0 0 8 10"
        fill="none"
    >
        <g clip-path="url(#clip0_2642_23359)">
            <path
                d="M4 9V1M4 1L1 4M4 1L7 4"
                stroke="#CACAD3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_2642_23359">
                <rect width="8" height="10" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script lang="ts" setup>
type Props = {
    direction?: string
}

const props = withDefaults(defineProps<Props>(), {
    direction: 'up',
})
</script>

<style lang="scss" scoped>
svg.down {
    transform: rotate(180deg);
}
</style>
